<template>
  <div class="wrapper">
    <template v-if="errorVisible && !loading">
      <slot name="error">
        <error-com handle-error @reload="handleReload" />
      </slot>
    </template>
    <template v-else-if="empty && !loading">
      <slot name="empty">
        <div class="empty-wrapper">
          <empty-com v-bind="emptyProps" :icon="emptyProps?.icon || 'goods'" />
          <slot name="empty-more" />
        </div>
      </slot>
    </template>
    <slot v-else />
  </div>
</template>

<script setup lang="ts">
/**
 * 包装容器，处理错误视图和空视图
 */
import { ref, watch } from 'vue'
import ErrorCom from './error/Default.vue'
import { EmptyProps, default as EmptyCom } from './empty/index.vue'

const props = withDefaults(
  defineProps<{
    /**
     * 是否包含错误
     */
    error?: Error | null
    /**
     * 是否加载中
     */
    loading?: boolean
    /**
     * 是否为空
     */
    empty?: boolean
    /**
     * 空视图属性
     */
    emptyProps?: EmptyProps | undefined
  }>(),
  {
    error: null,
    loading: false,
    empty: false,
    emptyProps: undefined
  }
)

const emits = defineEmits<{
  (e: 'update:error', value: null): void
  /**
   * 错误视图点击刷新按钮
   */
  (e: 'reload'): void
}>()

const errorVisible = ref(false)
watch(
  () => props.error,
  () => {
    errorVisible.value = !!props.error
  }
)
errorVisible.value = !!props.error
const handleReload = () => {
  emits('update:error', null)
  emits('reload')
}
</script>

<style lang="scss" scoped>
.wrapper {
  flex: 1;
  display: flex;
  flex-direction: column;

  .nav-bar-blank {
    padding-top: constant(safe-area-inset-top);
    padding-top: env(safe-area-inset-top);
    height: var(--van-nav-bar-height);
  }
}

.empty-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
</style>
